/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from "react-i18next";

import ContactUsDialog from "features/Checkout/ContactUsDialog";
import usePackage from "features/Checkout/Package/usePackage";

import { BILLING_CYCLES } from "utils/constants";

import Container from "components/Container";
import Content from "components/Content";
import { FormField } from "components/Form";
import { RadioGroup, RadioOption } from "components/RadioGroup";

import PackageCard from "./PackageCard";

export default function Package() {
  const { t } = useTranslation();

  const { packages, isPackagesLoading, form, handleChosePackage, handleOpenContact, isOpen, setIsOpen } = usePackage();

  return (
    <Content isLoading={isPackagesLoading}>
      <Container className="flex flex-col gap-6 pb-6">
        <div className="flex flex-col gap-4">
          <div>{t("checkout.package.choosePeriod")}</div>

          <FormField
            name="billingPeriod"
            control={form.control}
            render={({ field }) => (
              <RadioGroup defaultValue={field.value} onValueChange={field.onChange} className="grid grid-cols-2 gap-4">
                <RadioOption value={BILLING_CYCLES.YEARLY.toString()} label={t("checkout.yearly")} description="" />
                <RadioOption value={BILLING_CYCLES.MONTHLY.toString()} label={t("checkout.monthly")} description="" />
              </RadioGroup>
            )}
          />
        </div>
        <hr className="border-general-gray-300" />
        <div className="flex flex-col gap-4">
          <div>{t("checkout.package.choosePackage")}</div>
          <div className="flex flex-col gap-4">
            {packages?.resultList?.map((pkg: any) => (
              <PackageCard
                key={pkg.id}
                title={pkg.metadata.name}
                price={
                  form.watch("billingPeriod") === BILLING_CYCLES.YEARLY.toString()
                    ? pkg.package.pricePerYear
                    : pkg.package.pricePerMonth
                }
                period={form.watch("billingPeriod")}
                bestFit={pkg.metadata.bestFit}
                features={pkg.metadata.benefits}
                isPriceFlexible={pkg.package.isPriceFlexible}
                onSelect={() => (pkg.package.isPriceFlexible ? handleOpenContact(pkg.id) : handleChosePackage(pkg.id))}
              />
            ))}
          </div>
        </div>
        <ContactUsDialog open={isOpen} setOpen={setIsOpen} packageId={form.watch("packageId")} />
      </Container>
    </Content>
  );
}
